import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
const faqs = [{
  question: 'Do I need to buy expensive supplies?',
  answer: 'No. Everything in this book uses common household items like masking tape, colanders, socks, and cardboard boxes.'
}, {
  question: 'What if my child only plays for 5 minutes?',
  answer: 'The book includes "Play-Stretchers" to help you extend their focus time and build their "independent play muscle" over time.'
}, {
  question: 'Is this messy?',
  answer: 'The "Zero-Cleanup Rule" is built into every activity. We focus on dry materials and "sheet-contained" play areas.'
}, {
  question: 'How long does setup take?',
  answer: 'Every activity is designed to be set up in under 120 seconds.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-24 sm:py-32" data-id="element-50">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-51">
        <div className="mx-auto max-w-2xl text-center mb-16" data-id="element-52">
          <FadeIn data-id="element-53">
            <h2 className="font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl" data-id="element-54">
              Frequently Asked Questions
            </h2>
          </FadeIn>
        </div>

        <div className="mx-auto max-w-3xl" data-id="element-55">
          <div className="space-y-4" data-id="element-56">
            {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-57">
                <div className="border border-gray-200 rounded-2xl overflow-hidden transition-all duration-200 hover:border-amber-light" data-id="element-58">
                  <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between bg-white px-6 py-5 text-left" data-id="element-59">
                    <span className="font-semibold text-navy text-lg" data-id="element-60">
                      {faq.question}
                    </span>
                    <ChevronDown className={`h-5 w-5 text-muted transition-transform duration-200 ${openIndex === index ? 'rotate-180 text-amber' : ''}`} data-id="element-61" />
                  </button>
                  <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-62">
                    <p className="text-muted leading-relaxed" data-id="element-63">{faq.answer}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}